import React, { useEffect, useState } from 'react';
import '../../css/About.css'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import Collapsible from 'react-collapsible';
import Testimonial from './Testimonial';



function About() {
    useEffect(() => {
        document.documentElement.scrollTop = 0
    }, []);
    const [Accordion1, setAccordion1] = useState(true);
    const [Accordion2, setAccordion2] = useState(false);
    const [Accordion3, setAccordion3] = useState(false);
    const handleAccordion = (id) => {
        if (id === 1) {
            setAccordion1(true)
            setAccordion2(false)
            setAccordion3(false)
        }
        if (id === 2) {
            setAccordion1(false)
            setAccordion2(true)
            setAccordion3(false)
        }
        if (id === 3) {
            setAccordion1(false)
            setAccordion2(false)
            setAccordion3(true)
        }
    }
    return (
        <>

            <div className="row justify-content-center  w-100" style={{ margin: "15% 0 10% 0" }}>
                <div className="col-md-5 d-flex flex-column justify-content-evenly">
                    <div className="view overlay zoom  rounded my-3">
                        <img src={require('../../resource/about.jpg')} alt="" style={{ width: '100%', maxHeight: '250px' }} />
                        <div className="mask flex-center  rgba-purple-light">
                        </div>
                    </div>
                    <div className="view overlay zoom  rounded">
                        <img src={require('../../resource/about2.png')} alt="" style={{ width: '100%', maxHeight: '250px' }} />
                        <div className="mask flex-center  rgba-purple-light">
                        </div>
                    </div>
                </div>
                <div className="col-md-5 d-flex flex-column justify-content-evenly">
                    <h2 className="white-1">
                        Spread your wings across the Globe with DOTS.
                    </h2>
                    <p className="white-2">
                        The company is founded after watching the real world scenario of the education policy where in the students do have the theoretical knowledge of the technologies but when time comes to deal with real-time projects, they find difficulty for the same. As we have mentioned earlier, the company aims to remove the gap in teaching and learning process by providing the practical knowledge and also prepare them for their professional life. We do have hardworking team and experienced national and international faculties and mentors in the company who are fully dedicated to offer industrial projects, assistance and guidance for internship in abroad which turns into benefits of students. We make your dream true to study abroad by providing assistant to find admission and accommodation.
                    </p>
                    <h4 className="white-3">
                        “ Coming together is a beginning,
                        Keeping together is progress,
                        Working together is success”
                    </h4>
                </div>
            </div>


            <div style={{ marginBottom: "10%" }} >
                <div className="py-3 mb-4">
                    <h5 className="text-center white-3">GOALS TO ACHIEVE FOR THE LEADERSHIP</h5>
                    <h3 className="text-center white-1">Who are in extremely love with eco friendly system</h3>
                </div>
                <div className="row justify-content-center align-items-center w-100">
                    <div className="col-md-5">

                        <Collapsible trigger="Vision"
                            transitionTime={300}
                            className="white-text my-2"
                            triggerStyle={{ color: "white", background: "purple", padding: "5px", borderRadius: "5px 5px 0 0" }}
                            triggerTagName="div"
                            open={Accordion1}
                            onOpening={() => handleAccordion(1)}
                        >
                            <p className="white-3 p-style p-2"  >
                                Our vision is to be globally recognized" as a worlds best IT solutione company which satisfied the needs of his client's.
                            </p>
                        </Collapsible>
                        <Collapsible trigger="Focus"
                            transitionTime={300}
                            className="white-text my-2"
                            triggerStyle={{ color: "white", background: "purple", padding: "5px", borderRadius: "5px 5px 0 0", }}
                            triggerTagName="div"
                            open={Accordion3}
                            onOpening={() => handleAccordion(3)}
                        >
                            <p className="white-3 p-style p-2"  >
                                We focus to provide affordable services for client"s at lower cost.We value the clients time and money, so we handle every project seriously and give our best on the given project within given deadline                            </p>
                        </Collapsible>
                        <Collapsible trigger="Mission"
                            transitionTime={300}
                            className="white-text my-2"
                            triggerStyle={{ color: "white", background: "purple", padding: "5px", borderRadius: "5px 5px 0 0" }}
                            triggerTagName="div"
                            open={Accordion2}
                            onOpening={() => handleAccordion(2)}
                        >
                            <p className="white-3 p-style p-2"  >
                                Our mission is to bringing advanced digital technologies to help small, medium and big businesses which will provide maximum quality for new and established platform of customers                            </p>
                        </Collapsible>
                    </div>
                    <div className="col-md-5">
                        <div class="embed-responsive embed-responsive-16by9 hoverable">
                            <iframe class="embed-responsive-item" width="560" height="315" style={{ height: "101%" }} src="https://www.youtube.com/embed/chRx0xsLGAk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            {/* <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/fa3Iczgh8Ok" style={{height:"101%"}}
        allowfullscreen></iframe> */}
                        </div>
                    </div>
                </div>

            </div>


            <div className="p-3" style={{ marginBottom: "7%" }}>
                <div className="my-3">
                    <h2 className="text-center white-1 letter-dis-2">Our Team
                    </h2>
                </div>
                <div className="row justify-content-center py-3">
                    <div className="col-md-3 mx-2  " >
                        <div className=" purple p-2 img-wrapper">
                            <div className="view overlay zoom h-100">
                                <img src={require("../../resource/team/sumit.jpeg")} className="w-100 h-100" alt="" />
                            </div>
                        </div>
                        <h3 className="white-1 mt-2">Sumit Parashar</h3>
                        <h5 className="white-2">Director</h5>
                        <br />
                        <p className="white-3">Sumit Parashar is a 1st generation entrepreneur with over a decade experience in Digital Marketing. He started his career with US Calling process which helped her polish her communication skills, Sales & Marketing Skills</p>
                    </div>

                    <div className="col-md-3 mx-2  " >
                        <div className=" purple p-2 img-wrapper">
                            <div className="view overlay zoom h-100">
                                <img src={require("../../resource/team/bhola.jpg")} className="w-100 h-100" alt="" />
                            </div>
                        </div>
                        <h3 className="white-1 mt-2">Bhola Kumar</h3>
                        <h5 className="white-2">Associate CTO & Cheif project manager</h5>
                        <br />
                        <p className="white-3">Bhola kumar carries an extensive experience of 16 years with him. He started his career with KPO & HR Outsourcing and since last 3 years, he has established himself as Digital Leader.</p>
                    </div>

                    <div className="col-md-3 mx-2  " >
                        <div className=" purple p-2 img-wrapper">
                            <div className="view overlay zoom h-100 ">
                                <img src={require("../../resource/team/ashish.jpeg")} className="w-100 h-100" alt="" />
                            </div>
                        </div>
                        <h3 className="white-1 mt-2">Ashish Sharma</h3>
                        <h5 className="white-2">Associate operation manager</h5>
                        <br />
                        <p className="white-3">Ashish sharama working as a full stack developer. He have the experience needed to create , develop & design programs,API, applications and websites. He is familiar with modular and object oriented programming.</p>
                    </div>
                </div>
            </div>


            <div className="p-3" style={{ marginBottom: "7%" }}>
                <div className="row justify-content-center align-items-center" >
                    <div className="col-md-5">
                        <h5 className="white-2 letter-dis-1">From The CEO</h5>
                        <h3>Fun facts about the team and why people love us</h3>
                        <br />
                        <p className="white-3">He is currently running two start-up DOTS Pvt. Ltd. and Smart farming technology services, he have also received an award "India book of Record" for developing an "smart farming loT kit". In addition to it he is a founder of NGO ("Pramit Foundation educational Society"). Mr Soni is also an author of a book "The Melange of Success".</p>

                        <div className="white-2 letter-dis-1 d-flex justify-content-end">
                            - Praveen Soni <br />	&#160;	&#160;CEO & Director
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="p-2">
                            <img src={require("../../resource/team/praveen1.jpg")}  alt="" className="rounded-circle" style={{ boxShadow: "0 0 0 4px #BA12E9, 0 0 0 10px purple",height: "100%",width:"100%"  }} />
                        </div>

                    </div>
                </div>
            </div>

            <div className="p-3"  >
                <h5 className="white-2 text-center letter-dis-1">STUDENT REVIEWS
                </h5>
                <h3 className="white-1 text-center letter-dis-1">
                    What Our Students Says
                </h3>
            </div>
            <Testimonial />
        </>

    )
}

export default About;
